module.exports = __webpack_public_path__ + "img/lactose.0cfaaafd.svg";